/* eslint-disable */
import React, { useEffect, useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styles from "./DraggableList.module.css";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import useResponsive from "../../../common/useResponsive";
// import { Theme } from "@mui/material/styles";

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     menuButton: {
//       marginRight: theme.spacing(2),
//     },
//   })
// );

interface DraggableListProps {
  // リストを区別ため
  type: string;
  // 対象リスト
  targetList: DraggableItem[];
  // クリックコールバック関数
  onClick?: any;
  // リスト更新用コールバック関数
  onUpdate?: any;
  // クリック対象
  currentId?: string;
  // リストの高さ(px)
  listHeight?: number;
  // 表示する項目数
  showListNum?: number;
}

interface DraggableItem {
  id: string;
  title: string;
}

const DraggableList = React.forwardRef<HTMLInputElement, DraggableListProps>(
  function DraggableList(props, ref) {
    const { listHeight = 300 } = props;
    const { isMobile } = useResponsive();
    // const classes = useStyles();
    const [draggable, setDraggable] = useState<DraggableItem[]>();

    useEffect(() => {
      setDraggable(props.targetList);
    }, [props.targetList]);

    // 項目削除
    const handleClick = (id: string, index: number) => {
      console.log(id, index);
      const element = document.getElementById(`${props.type}-${id}`);
      if (element) element.style.display = "none";

      // リスト更新（項目削除）
      const order = Array.from(draggable || []);
      order.splice(index, 1);
      setDraggable(order);
      if (props.onUpdate) props.onUpdate(props.type, order);
    };

    // 並び替え
    const onDragEnd = (result: any) => {
      console.log("onDrag: ", result);

      // 項目がリスト以外に移動した場合
      if (!result.destination) return;

      // リストの順番を変更
      const reorder = Array.from(draggable || []);
      const [removed] = reorder.splice(result.source.index, 1);
      reorder.splice(result.destination.index, 0, removed);
      // 新しい順番をセット
      setDraggable(reorder);

      // リスト順変更あるか
      if (result.source.index !== result.destination.index) {
        if (props.onUpdate) props.onUpdate(props.type, reorder);
      }
    };

    // リスト項目情報取得
    const selectInfo = (targetId: string) => {
      console.log(targetId);
      if (props.onClick) props.onClick(targetId);
    };

    return (
      <>
        <div className={styles.root}>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ height: String(listHeight) + "px" }}
                  className={styles.list}
                >
                  {draggable &&
                    draggable.map((target, index) => (
                      <Draggable
                        key={target.id}
                        draggableId={String(target.id)}
                        index={index}
                      >
                        {(provided) => (
                          <AppBar
                            key={`${props.type}-${target.id}`}
                            id={`${props.type}-${target.id}`}
                            position="static"
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            ref={provided.innerRef}
                          >
                            <Toolbar
                              variant="dense"
                              style={{
                                background:
                                  props.currentId === target.id
                                    ? "var(--red)"
                                    : "white",
                                border: "1px solid black",
                                paddingRight: "0",
                                paddingLeft: "0",
                              }}
                            >
                              <IconButton
                                edge="start"
                                // className={classes.menuButton}
                                aria-label="menu"
                                disabled={true}
                              >
                                <MenuIcon
                                  style={{
                                    color:
                                      props.currentId === target.id
                                        ? "white"
                                        : "var(--red)",
                                    width: isMobile ? "28px" : "40px",
                                    height: isMobile ? "28px" : "40px",
                                    marginLeft: "5px",
                                  }}
                                />
                              </IconButton>
                              <Typography
                                variant="h6"
                                onClick={() => selectInfo(`${target.id}`)}
                                style={{
                                  color:
                                    props.currentId === target.id
                                      ? "white"
                                      : "black",
                                  fontSize: isMobile? "14px" : "18px",
                                  marginLeft: isMobile ? "-5px" : "-10px",
                                  width: "100%",
                                  height: isMobile ? "42px" : "56px",
                                  lineHeight: "3",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                }}
                                data-tip={target.title}
                                data-for="title"
                              >
                                {target.title}
                              </Typography>
                              <PuiTooltip id="title" />
                              <IconButton
                                edge="start"
                                aria-label="menu"
                                onClick={() => handleClick(target.id, index)}
                              >
                                <CancelIcon
                                  style={{
                                    color:
                                      props.currentId === target.id
                                        ? "white"
                                        : "gray",
                                        width: isMobile ? "28px" : "40px",
                                        height: isMobile ? "28px" : "40px",
                                  }}
                                />
                              </IconButton>
                              {props.currentId === target.id && (
                                <ArrowRightIcon
                                  style={{
                                    color: "white",
                                    width: isMobile ? "28px" : "40px",
                                    height: isMobile ? "28px" : "40px",
                                    position: "absolute",
                                    right: "-11px",
                                  }}
                                />
                              )}
                            </Toolbar>
                          </AppBar>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </>
    );
  }
);

export default DraggableList;
